import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import config from '../../config';
import Title from './title';

const CompanyFilials = () => {
  const user = useSelector(state => state.user.currentUser);
  const [filials, setFilials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreateFilial, setShowCreateFilial] = useState(false);
  const [newFilial, setNewFilial] = useState({
    filialName: '',
    filialAddress: '',
    filialPhone: '',
    filialEmail: ''
  });

  useEffect(() => {
    if (user?.role === 'company_admin') {
      loadFilials();
    }
  }, [user]);

  const loadFilials = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${config.apiUrl}/api/filial`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setFilials(response.data);
    } catch (error) {
      console.error('Ошибка загрузки филиалов:', error);
      alert('Ошибка загрузки филиалов');
    } finally {
      setLoading(false);
    }
  };

  const handleCreateFilial = async () => {
    try {
      if (!newFilial.filialName.trim() || !newFilial.filialAddress.trim()) {
        alert('Заполните обязательные поля: название и адрес филиала');
        return;
      }

      await axios.post(`${config.apiUrl}/api/filial/addFilial`, newFilial, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      alert('Филиал создан успешно!');
      setNewFilial({
        filialName: '',
        filialAddress: '',
        filialPhone: '',
        filialEmail: ''
      });
      setShowCreateFilial(false);
      loadFilials();
    } catch (error) {
      console.error('Ошибка создания филиала:', error);
      alert(error.response?.data?.message || 'Ошибка создания филиала');
    }
  };

  const handleToggleFilialStatus = async (filialId, isActive) => {
    try {
      await axios.put(`${config.apiUrl}/api/filial/${filialId}/status`, {
        isActive: !isActive
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      alert(`Филиал ${!isActive ? 'активирован' : 'деактивирован'} успешно!`);
      loadFilials();
    } catch (error) {
      console.error('Ошибка изменения статуса филиала:', error);
      alert('Ошибка изменения статуса филиала');
    }
  };

  if (loading) {
    return <div className="dashboard-content">Загрузка...</div>;
  }

  return (
    <div className="dashboard-content">
      <Title title="Управление филиалами" />

      <div className="section-header">
        <button
          className="btn-primary"
          onClick={() => setShowCreateFilial(true)}
        >
          Добавить филиал
        </button>
      </div>

      {showCreateFilial && (
        <div className="modal">
          <div className="modal-content">
            <h3>Создание нового филиала</h3>
            <input
              type="text"
              placeholder="Название филиала *"
              value={newFilial.filialName}
              onChange={(e) => setNewFilial({...newFilial, filialName: e.target.value})}
              required
            />
            <input
              type="text"
              placeholder="Адрес филиала *"
              value={newFilial.filialAddress}
              onChange={(e) => setNewFilial({...newFilial, filialAddress: e.target.value})}
              required
            />
            <input
              type="text"
              placeholder="Телефон филиала"
              value={newFilial.filialPhone}
              onChange={(e) => setNewFilial({...newFilial, filialPhone: e.target.value})}
            />
            <input
              type="email"
              placeholder="Email филиала"
              value={newFilial.filialEmail}
              onChange={(e) => setNewFilial({...newFilial, filialEmail: e.target.value})}
            />
            <div className="modal-actions">
              <button onClick={handleCreateFilial}>Создать</button>
              <button onClick={() => setShowCreateFilial(false)}>Отмена</button>
            </div>
          </div>
        </div>
      )}

      <div className="filials-list">
        {filials.map(filial => (
          <div key={filial._id} className="filial-card">
            <div className="filial-info">
              <h3>{filial.filialName}</h3>
              <p><strong>Адрес:</strong> {filial.filialAddress}</p>
              {filial.filialPhone && <p><strong>Телефон:</strong> {filial.filialPhone}</p>}
              {filial.filialEmail && <p><strong>Email:</strong> {filial.filialEmail}</p>}
              <p><strong>Статус:</strong>
                <span className={filial.isActive ? 'status-active' : 'status-inactive'}>
                  {filial.isActive ? ' Активен' : ' Неактивен'}
                </span>
              </p>
            </div>
            <div className="filial-actions">
              <button
                className={filial.isActive ? 'btn-danger' : 'btn-success'}
                onClick={() => handleToggleFilialStatus(filial._id, filial.isActive)}
              >
                {filial.isActive ? 'Деактивировать' : 'Активировать'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompanyFilials;